import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import '../styles/VerifyVoucherPage.css';

export default function VerifyVoucherPage() {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchVoucher = async () => {
      try {
        setLoading(true);
        setError(null);
        const res = await axios.get(`/api/public/verify-voucher/${id}`);
        setData(res.data);
      } catch (err) {
        console.error('Voucher verification error:', err);
        setError(err.response?.data?.error || 'Ushbu yoʻllanma varaqasi tizimda topilmadi yoki raqam notoʻgʻri kiritilgan.');
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchVoucher();
    }
  }, [id]);

  if (loading) {
    return (
      <div className="verify-page-wrapper loading-state">
        <div className="verify-container">
          <div className="verify-spinner"></div>
          <p className="loading-txt">Turon universiteti rasmiy bazasidan yoʻllanma maʼlumotlari tekshirilmoqda...</p>
        </div>
      </div>
    );
  }

  if (error || !data || !data.applicant) {
    return (
      <div className="verify-page-wrapper error-state">
        <div className="verify-card error-card">
          <div className="verify-error-badge">⚠️</div>
          <h2>Yoʻllanma tasdiqlanmadi</h2>
          <p className="error-desc">{error || 'Maʼlumotlar topilmadi.'}</p>
          <div className="verify-btn-group">
            <Link to="/" className="btn-verify-primary">Bosh sahifaga qaytish</Link>
          </div>
        </div>
      </div>
    );
  }

  const a = data.applicant;
  const isPassed = a.status === 'passed';
  const isApproved = a.status === 'approved';

  return (
    <div className="verify-page-wrapper">
      <div className="verify-container">
        {/* Verification Success Header */}
        <div className="verify-card verified-main-card">
          <div className="verify-top-seal">
            <div className="seal-univ-meta">
              <img src="/logo.png" alt="Turon universiteti" className="verify-logo" />
              <div>
                <span className="verify-ministry-text">OʻZBEKISTON RESPUBLIKASI TAʼLIM VA ILM-FAN VAZIRLIGI</span>
                <h1 className="verify-univ-title">TURON UNIVERSITETI</h1>
                <span className="verify-dept-sub">Elektron hujjatlar verifikatsiyasi va ilmiy boʻlim reestri</span>
              </div>
            </div>
            <div className="qr-official-stamp">
              <span className="stamp-title">TURON UNIV.</span>
              <span className="stamp-center">QR-VERIFIED</span>
              <span className="stamp-sub">★ 2026 ★</span>
            </div>
          </div>

          <div className="verification-status-banner">
            <div className="status-banner-icon">✓</div>
            <div className="status-banner-text">
              <h3>RASMIY YOʻLLANMA VA ARIZA TASDIQLANDI</h3>
              <p>
                Ushbu hujjat Turon universiteti malakaviy imtihonlar axborot tizimida haqiqatan rasmiylashtirilgan
                va ilmiy kengash kotibiyati tomonidan qonuniy tasdiqlangan.
              </p>
            </div>
            <div className="verified-number-pill">
              Ariza raqami: <strong>№ {a.id}</strong>
            </div>
          </div>

          {/* Exam Result / Status Banner */}
          {isPassed && (
            <div className="exam-result-banner-box passed">
              <div className="erb-icon">🏆</div>
              <div className="erb-content">
                <h4>MALAKAVIY IMTIHON SINOVI TOPSHIRILGAN (MUVAFFAQIYATLI)</h4>
                <p>
                  Talabgor offline malakaviy imtihon komissiyasi huzurida sinovdan muvaffaqiyatli oʻtgan.
                  Toʻplagan yakuniy natijasi: <strong>{a.score || (a.examResult && a.examResult.score) || 85} ball</strong>.
                  {a.certificateNumber && ` Rasmiy qaydnoma raqami: ${a.certificateNumber}.`}
                </p>
              </div>
            </div>
          )}

          {isApproved && (
            <div className="exam-result-banner-box approved">
              <div className="erb-icon">🏛️</div>
              <div className="erb-content">
                <h4>OFFLINE MALAKAVIY IMTIHONGA RASMAN RUXSAT BERILGAN</h4>
                <p>
                  Talabgor taqdim etgan barcha hujjatlar ekspertizadan oʻtgan. Belgilangan sana va vaqtda
                  Turon universitetida oʻtkaziladigan offline imtihonda ishtirok etishi tasdiqlangan.
                </p>
              </div>
            </div>
          )}

          {/* Table of Applicant & Exam Details */}
          <div className="verify-table-section">
            <h3 className="section-head-title">Yoʻllanma va talabgor rasmiy maʼlumotlari</h3>
            <table className="verify-details-table">
              <tbody>
                <tr>
                  <td className="lbl">Ariza va yoʻllanma raqami:</td>
                  <td className="val"><strong>№ {a.id}</strong></td>
                  <td className="lbl">Rasmiylashtirilgan sana:</td>
                  <td className="val">{new Date(a.created_at || Date.now()).toLocaleDateString('uz-UZ')}</td>
                </tr>
                <tr>
                  <td className="lbl">Talabgor F.I.Sh. (Toʻliq):</td>
                  <td className="val highlight" colSpan="3"><strong>{a.fullName}</strong></td>
                </tr>
                <tr>
                  <td className="lbl">JSHSHIR raqami:</td>
                  <td className="val mono">{a.passportNumber || '—'}</td>
                  <td className="lbl">Telefon raqami:</td>
                  <td className="val">{a.phoneNumber || '—'}</td>
                </tr>
                <tr>
                  <td className="lbl">Biriktirilgan muassasa (OTM):</td>
                  <td className="val" colSpan="3">{a.otmName || 'Turon universiteti'} ({a.positionAndTitle || 'Tadqiqotchi'})</td>
                </tr>
                <tr>
                  <td className="lbl">Imtihon fani / Ixtisoslik:</td>
                  <td className="val highlight" colSpan="3"><strong>{a.specialization}</strong></td>
                </tr>
                <tr>
                  <td className="lbl">Dissertatsiya mavzusi:</td>
                  <td className="val italic" colSpan="3">«{a.dissertationTopic || 'Mavzu kiritilgan'}»</td>
                </tr>
                <tr>
                  <td className="lbl">Imtihon shakli:</td>
                  <td className="val" colSpan="3">
                    <span className="mode-pill">🏛️ OFFLINE (Turon universitetida anʼanaviy tartibda)</span>
                  </td>
                </tr>
                <tr>
                  <td className="lbl">Belgilangan sana va vaqt:</td>
                  <td className="val"><strong>📅 {a.testDate || '2026-10-25'} | ⏰ {a.testTime || '09:00'}</strong></td>
                  <td className="lbl">Imtihon oʻtish bali:</td>
                  <td className="val">60% (Ijobiy)</td>
                </tr>
                <tr>
                  <td className="lbl">Bino va auditoriya:</td>
                  <td className="val" colSpan="3">{a.examRoom || 'Turon universiteti bosh binosi, 214-auditoriya'}</td>
                </tr>
                {a.examNotes && (
                  <tr>
                    <td className="lbl">Komissiya koʻrsatmasi:</td>
                    <td className="val notes" colSpan="3">{a.examNotes}</td>
                  </tr>
                )}
                {a.examResult && (
                  <tr className="result-highlight-row">
                    <td className="lbl">Offline imtihon natijasi:</td>
                    <td className="val highlight-gold" colSpan="3">
                      <strong>{a.examResult.score} ball ({a.examResult.status === 'passed' ? '✓ Sinovdan oʻtgan' : '✕ Oʻta olmagan'})</strong>
                      {a.examResult.certificateNumber && ` | Qayd: ${a.examResult.certificateNumber}`}
                      {a.examResult.resultNotes && ` | Xulosa: ${a.examResult.resultNotes}`}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Action buttons */}
          <div className="verify-actions-footer">
            <button className="btn-verify-act print" onClick={() => window.print()}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="6 9 6 2 18 2 18 9"></polyline><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path><rect x="6" y="14" width="12" height="8"></rect></svg>
              <span>Yoʻllanmani chop etish (Print)</span>
            </button>
            <a
              href="/Ariza_Namunasi.pdf"
              download="Ariza_Namunasi.pdf"
              className="btn-verify-act download"
            >
              📥 Ariza namunasini yuklab olish
            </a>
            <Link to="/" className="btn-verify-act home">
              🏛️ Universitet portaliga oʻtish →
            </Link>
          </div>

          <div className="verify-footer-legal">
            <span>Turon universiteti elektron reestri | Rasmiy sayt: https://turonuniversity.uz/ru# | Aloqa: +998 (75) 220-00-25 | Qarshi sh., Nasaf koʻchasi, 1/14</span>
          </div>
        </div>
      </div>
    </div>
  );
}
